/* HIT na Trávenie+® — customer video-review wall (snippets/iprobio-hit-video-wall.liquid), 2026-10-14.
   - Arrival: pieces reveal (desktop staggered; phones one by one as each card enters), dot matrix + one sweep.
   - One active card at a time: reticle converges, scan line runs, its 6 s muted loop plays; the readout types the quote.
   - Desktop: hover/focus/arrows choose the card; otherwise it advances every 7 s while the wall is in view
     (a user choice holds it for 12 s). Phones: the card in the middle of the screen is the active one.
   - Card click / „Prehrať so zvukom" opens the player (<dialog>) with the full video and sound; ← → switch records.
   - Reduced motion / Save-Data: no loops, no typing, no auto-advance. No JS: cards are links to the video files. */
(function () {
    'use strict';
    var root = document.querySelector('[data-hvw]');
    if (!root || root.__hvw) return;
    root.__hvw = true;
    var d = document, w = window;
    var mq = function (q) { return w.matchMedia ? w.matchMedia(q) : { matches: false, addEventListener: function () {} }; };
    var reduce = mq('(prefers-reduced-motion: reduce)').matches;
    var saveData = !!(navigator.connection && navigator.connection.saveData);
    var phone = mq('(max-width: 699px)');
    var hoverable = mq('(hover: hover) and (pointer: fine)');
    var cards = [].slice.call(root.querySelectorAll('.hvw-card'));
    var n = cards.length;
    if (!n) return;
    var CYCLE = 7000, HOLD = 12000;
    var active = -1, inView = false, holdUntil = 0, timer = 0, typing = 0;
    var ro = {
        body: root.querySelector('.hvw-ro-body'),
        idx: root.querySelector('.hvw-ro-idx'),
        time: root.querySelector('.hvw-ro-time'),
        name: root.querySelector('.hvw-ro-name'),
        prod: root.querySelector('.hvw-ro-prod'),
        quote: root.querySelector('.hvw-ro-quote'),
        play: root.querySelector('[data-hvw-open]'),
        live: root.querySelector('[data-hvw-live]')
    };
    root.classList.add('hvw-js');
    [].forEach.call(root.querySelectorAll('[data-hvw-step],[data-hvw-open]'), function (b) { b.hidden = false; });
    root.style.setProperty('--hvw-cycle', CYCLE + 'ms');

    function pad(i) { return (i < 9 ? '0' : '') + (i + 1); }
    function loopOf(card) { return card.querySelector('.hvw-loop'); }

    /* ---------- readout ---------- */
    function typeQuote(text) {
        w.clearTimeout(typing);
        if (reduce) { ro.quote.textContent = text; return; }
        var i = 0, caret = d.createElement('span');
        caret.className = 'hvw-caret';
        ro.quote.textContent = '';
        var node = d.createTextNode('');
        ro.quote.appendChild(node); ro.quote.appendChild(caret);
        (function step() {
            i = Math.min(text.length, i + 2);
            node.nodeValue = text.slice(0, i);
            if (i < text.length) typing = w.setTimeout(step, 22);
            else typing = w.setTimeout(function () { if (caret.parentNode) caret.parentNode.removeChild(caret); }, 1400);
        })();
    }
    function fillReadout(c, i) {
        ro.idx.textContent = pad(i);
        ro.time.textContent = c.getAttribute('data-time');
        ro.name.textContent = c.getAttribute('data-name');
        ro.prod.textContent = c.getAttribute('data-prod');
        ro.body.classList.remove('is-swap'); void ro.body.offsetWidth; ro.body.classList.add('is-swap');
        typeQuote('„' + c.getAttribute('data-quote') + '“');
        var label = ro.play && ro.play.querySelector('span');
        if (label) label.textContent = c.getAttribute('data-sound') === '0' ? 'Prehrať video' : 'Prehrať so zvukom';
    }

    /* ---------- loops: only the active card decodes video ---------- */
    function stopLoop(card) {
        card.classList.remove('is-playing');
        var v = loopOf(card);
        if (v && !v.paused) v.pause();
    }
    function playLoop(card) {
        if (reduce || saveData || !inView || d.hidden || (dlg && dlg.open)) return;
        var v = loopOf(card);
        if (!v) return;
        v.muted = true;
        if (!v.getAttribute('src')) { v.setAttribute('src', card.getAttribute('data-loop')); v.load(); }
        var on = function () { if (cards[active] === card) card.classList.add('is-playing'); };
        var p = v.play();
        if (p && p.then) p.then(on, function () {}); else on();
    }

    function setActive(i, opts) {
        opts = opts || {};
        i = ((i % n) + n) % n;
        if (i === active && !opts.force) return;
        if (active > -1) { cards[active].classList.remove('is-active', 'is-scan'); stopLoop(cards[active]); }
        active = i;
        var c = cards[i];
        c.classList.add('is-active');
        if (!reduce) { void c.offsetWidth; c.classList.add('is-scan'); }
        playLoop(c);
        fillReadout(c, i);
        restartBar();
        if (opts.announce && ro.live) ro.live.textContent = 'Videorecenzia ' + (i + 1) + ' z ' + n + ': ' + c.getAttribute('data-name');
    }

    /* ---------- auto-advance (desktop, in view, not held) ---------- */
    function canCycle() { return inView && !reduce && !phone.matches && !d.hidden && !(dlg && dlg.open); }
    function restartBar() {
        root.classList.remove('is-cycling');
        if (!canCycle() || Date.now() < holdUntil) return;
        void root.offsetWidth;
        root.classList.add('is-cycling');
    }
    function schedule() {
        w.clearTimeout(timer);
        if (!canCycle()) return;
        var wait = Math.max(CYCLE, holdUntil - Date.now());
        timer = w.setTimeout(function () {
            if (!canCycle()) return;
            if (Date.now() < holdUntil) { schedule(); return; }
            setActive(active + 1);
            schedule();
        }, wait);
    }
    function hold() { holdUntil = Date.now() + HOLD; root.classList.remove('is-cycling'); schedule(); }

    /* ---------- arrival + visibility ---------- */
    var pieces = [].slice.call(root.querySelectorAll('.hvw-piece'));
    function revealAll() { pieces.forEach(function (p) { p.classList.add('is-in'); }); root.classList.add('is-on'); }
    if (reduce || !('IntersectionObserver' in w)) {
        revealAll();
    } else {
        var pio = new IntersectionObserver(function (entries) {
            var wide = !phone.matches;
            entries.forEach(function (e) {
                if (!e.isIntersecting) return;
                var p = e.target;
                var idx = parseInt(p.style.getPropertyValue('--i') || '0', 10) || 0;
                p.style.setProperty('--hvw-d', (wide ? Math.min(idx, 6) * 70 : 0) + 'ms');
                p.classList.add('is-in');
                pio.unobserve(p);
            });
        }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
        pieces.forEach(function (p) { pio.observe(p); });
    }
    if ('IntersectionObserver' in w) {
        new IntersectionObserver(function (entries) {
            var was = inView;
            inView = entries[0].isIntersecting;
            if (inView) {
                root.classList.add('is-on');
                if (active < 0) setActive(0, { force: true }); else if (!was) { playLoop(cards[active]); restartBar(); }
                schedule();
            } else {
                w.clearTimeout(timer);
                root.classList.remove('is-cycling');
                if (active > -1) stopLoop(cards[active]);
            }
        }, { threshold: 0.2 }).observe(root);
        /* phones: the card in the middle band of the screen is the active one */
        var cio = new IntersectionObserver(function (entries) {
            if (!phone.matches) return;
            entries.forEach(function (e) { if (e.isIntersecting) setActive(cards.indexOf(e.target)); });
        }, { rootMargin: '-38% 0px -38% 0px', threshold: 0 });
        cards.forEach(function (c) { cio.observe(c); });
    } else {
        inView = true; setActive(0, { force: true });
    }
    d.addEventListener('visibilitychange', function () {
        if (d.hidden) { w.clearTimeout(timer); if (active > -1) stopLoop(cards[active]); }
        else if (inView && active > -1) { playLoop(cards[active]); schedule(); }
    });

    /* ---------- desktop pointer / keyboard choice ---------- */
    cards.forEach(function (c, i) {
        c.addEventListener('mouseenter', function () { if (hoverable.matches) { setActive(i); hold(); } });
        c.addEventListener('focus', function () { setActive(i); hold(); });
    });
    [].forEach.call(root.querySelectorAll('[data-hvw-step]'), function (b) {
        b.addEventListener('click', function () { setActive(active + parseInt(b.getAttribute('data-hvw-step'), 10), { announce: true }); hold(); });
    });

    /* ---------- player ---------- */
    var dlg = root.querySelector('.hvw-dlg');
    var dv = dlg && dlg.querySelector('.hvw-dlg-video');
    var cur = 0, opener = null;
    var di = dlg && {
        idx: dlg.querySelector('.hvw-dlg-idx b'),
        name: dlg.querySelector('.hvw-dlg-name'),
        prod: dlg.querySelector('.hvw-dlg-prod'),
        quote: dlg.querySelector('.hvw-dlg-quote')
    };
    function fillDialog(c, i) {
        di.idx.textContent = pad(i);
        di.name.textContent = c.getAttribute('data-name');
        di.prod.textContent = c.getAttribute('data-prod');
        di.quote.textContent = '„' + c.getAttribute('data-quote') + '“';
        var ar = (c.getAttribute('data-ar') || '9/16').split('/');
        var arw = (parseFloat(ar[0]) || 9) / (parseFloat(ar[1]) || 16);
        dlg.style.setProperty('--ar', ar[0] + ' / ' + ar[1]);
        dlg.style.setProperty('--arw', arw.toFixed(4));
    }
    function openAt(i) {
        if (!dlg || typeof dlg.showModal !== 'function') return false;
        cur = ((i % n) + n) % n;
        var c = cards[cur];
        if (!dlg.open) opener = d.activeElement;
        fillDialog(c, cur);
        dv.setAttribute('src', c.getAttribute('href'));
        dv.muted = false;
        if (!dlg.open) dlg.showModal();
        w.clearTimeout(timer); root.classList.remove('is-cycling');
        setActive(cur, { force: true });      /* keeps the wall in step; playLoop is a no-op while the dialog is open */
        var p = dv.play();
        if (p && p.catch) p.catch(function () { /* the visible controls let the visitor start it */ });
        return true;
    }
    cards.forEach(function (c, i) {
        c.addEventListener('click', function (e) {
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
            if (openAt(i)) e.preventDefault();
        });
    });
    if (ro.play) ro.play.addEventListener('click', function () { if (!openAt(Math.max(active, 0))) w.location.href = cards[Math.max(active, 0)].href; });
    if (dlg) {
        [].forEach.call(dlg.querySelectorAll('[data-hvw-dlg-step]'), function (b) {
            b.addEventListener('click', function () { openAt(cur + parseInt(b.getAttribute('data-hvw-dlg-step'), 10)); });
        });
        dlg.querySelector('.hvw-dlg-close').addEventListener('click', function () { dlg.close(); });
        dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.classList.contains('hvw-dlg-frame')) dlg.close(); });
        dlg.addEventListener('keydown', function (e) {
            if (e.target === dv) return;           /* arrows on the video seek */
            if (e.key === 'ArrowRight') { e.preventDefault(); openAt(cur + 1); }
            else if (e.key === 'ArrowLeft') { e.preventDefault(); openAt(cur - 1); }
        });
        dlg.addEventListener('close', function () {
            dv.pause(); dv.removeAttribute('src'); dv.load();
            hold();
            if (inView && active > -1) playLoop(cards[active]);
            if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (err) { opener.focus(); } }
            opener = null;
        });
    }

})();
